// Package imports:
import React from 'react';
// Component imports:
import ViewNewsArticle from '../../components/ViewNewsArticle/ViewNewsArticle';
import Entrypoint from '../Entrypoint';
import { INewsLmdNewsItem } from '../../types/NewsTypes';

interface IProps {
    id: string,
    newsItem: INewsLmdNewsItem | null
}

const ViewArticle: React.FC<IProps> = ({
    id,
    newsItem
}) => {
    return (
        <Entrypoint>
            <ViewNewsArticle id={id} newsItem={newsItem} />
        </Entrypoint>
    );
}

export default ViewArticle;